import LongNameFormatter from "@components/formatters/long-name-formatter";
import { Link, useParams } from "react-router-dom";

export const decoColumns = () => {
    const { platformId } = useParams();
    return [
        {
            name : "Company Name",
            width: "280px",
            cell : (row) => (
                <LongNameFormatter
                    tag={Link}
                    to={`/product/${platformId}/companies/${row._id}`}
                    content={row.company_name}
                    className=""
                    id={`company-${row._id}`}
                    max={30}/>
            )
        },
        {
            name : "CSM",
            width: "250px",
            cell : (row) => <span>{row.csm?.name || "_"}</span>
        },
        {
            name : "SDR",
            width: "250px",
            cell : (row) => <span>{row.sdr?.name || "_"}</span>
        },
        {
            name : "Stage",
            width: "290px",
            cell : (row) => <span>{row.stage?.name || "_"}</span>
        }
    ];
};
